import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../../../elements/button'
import DataSelection from '../../../../setScope/_components/uploadData/dataSelection'
import { SelectedDataTableType } from '../../../../../../_config/types'
import { trackEvent } from '../../../../../../_common/functions'
import { useExperimentSelector } from '../../../../../../store/selectors/experimentSelector'

interface Props {
    _ref: any
    onContinue: (data: any) => void
}

const MteMeasurementModal: React.FC<Props> = ({ _ref, onContinue }) => {
    const { t } = useTranslation()
    const experiment = useExperimentSelector()
    const [selectedKpiMeasurementTable, setSelectedKpiMeasurementTable] = useState<SelectedDataTableType | null>(null)
    const [selectedRecMeasurementTable, setSelectedRecMeasurementTable] = useState<SelectedDataTableType | null>(null)

    const updateWithMeasurementTableData = () => {
        if (onContinue) {
            onContinue({
                kpi: selectedKpiMeasurementTable?.table?.name,
                rec: selectedRecMeasurementTable?.table?.name,
            })
        }
    }

    useEffect(() => {
        if (_ref?.current) {
            const originalShowModal = _ref.current.showModal
            _ref.current.showModal = function () {
                setSelectedKpiMeasurementTable(null)
                setSelectedRecMeasurementTable(null)
                trackEvent('wizard_mte_measurement_modal_opened', { experiment_literal: experiment?.experiment_literal })
                originalShowModal.call(this)
            }

            _ref.current.addEventListener('cancel', () => {
                setSelectedKpiMeasurementTable(null)
                setSelectedRecMeasurementTable(null)
                trackEvent('wizard_mte_measurement_modal_closed', { experiment_literal: experiment?.experiment_literal })
            })
        }
    }, [])

    useEffect(() => {
        if (selectedKpiMeasurementTable) {
            trackEvent('wizard_mte_kpi_table_selected', { experiment_literal: experiment?.experiment_literal, table_name: selectedKpiMeasurementTable?.table?.name })
        }
    }, [selectedKpiMeasurementTable])

    useEffect(() => {
        if (selectedRecMeasurementTable) {
            trackEvent('wizard_mte_intervention_table_selected', { experiment_literal: experiment?.experiment_literal, table_name: selectedRecMeasurementTable?.table?.name })
        }
    }, [selectedRecMeasurementTable])

    return (
        <dialog ref={_ref} className="modal">
            <div className="modal-box w-11/12 max-w-5xl">
                <p className="text-[1.125rem] font-bold mb-2">{t('Measurement Data Selection')}</p>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <p className="text-[1rem] text-[#0F0F0F] font-bold mb-[0.125rem]">{t('KPI Data:')}</p>
                        <p className="text-[0.79rem] text-[#676767] leading-[1.2rem] mb-2">{t('Ensure your document includes these columns: Granularity, Date, KPI, and Group for seamless data processing.')}</p>
                        <DataSelection _for="measurement" selectedDataTable={setSelectedKpiMeasurementTable} />
                    </div>

                    <div>
                        <p className="text-[1rem] text-[#0F0F0F] font-bold mb-[0.125rem]">{t('Intervention Data:')}</p>
                        <p className="text-[0.79rem] text-[#676767] leading-[1.2rem] mb-2">{t('Ensure your document includes Granularity, Interventions for seamless data processing.')}</p>
                        <DataSelection _for="measurement" selectedDataTable={setSelectedRecMeasurementTable} />
                    </div>
                </div>

                <div className="flex items-center justify-end my-4 ">
                    <div className="flex items-center gap-3">
                        <Button
                            theme="secondary"
                            size="xs"
                            styleType="outline"
                            onClick={() => {
                                _ref.current.close()
                            }}
                        >
                            {t('Cancel')}
                        </Button>
                        <Button
                            theme="secondary"
                            size="xs"
                            className="text-white"
                            disabled={!selectedKpiMeasurementTable || !selectedRecMeasurementTable}
                            onClick={() => {
                                trackEvent('wizard_mte_measurement_next_clicked', { experiment_literal: experiment?.experiment_literal })
                                updateWithMeasurementTableData()
                            }}
                        >
                            {t('NEXT STEP')}
                        </Button>
                    </div>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button type="button">{t('close')}</button>
            </form>
        </dialog>
    )
}

export default MteMeasurementModal
